import { render } from "./entities-menu.vue?vue&type=template&id=1728fcf9&ts=true"
import script from "./entities-menu.component.ts?vue&type=script&lang=ts&external"
export * from "./entities-menu.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__